<div style="background: #1a1e4b;">
    <div class="container">
        <footer class="pb-3 pt-5">
            <div class="d-flex align-items-center justify-content-center flex-sm-row flex-column px-2">
                <div class="px-4" style="min-width: fit-content;">
                    <img src="../../../../assets/footer-logo.png" style="max-width: 200px;">
                </div>
                <div class="px-4 footer-vertical-border" style="min-width: fit-content;">
                    <ul class="nav justify-content-center pb-3 mb-3">
                        <li class="nav-item"><a target="_blank" href="{{environment.social.facebook}}"
                                class="px-3 social-icon"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                        <li class="nav-item"><a target="_blank" href="{{environment.social.instagram}}"
                                class="px-3 social-icon"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                        <li class="nav-item"><a target="_blank" href="{{environment.social.twitter}}"
                                class="px-3 social-icon"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                        <li class="nav-item"><a target="_blank" href="{{environment.social.linkedin}}"
                                class="px-3 social-icon"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                    </ul>
                    <p class="text-center text-white"> © {{cdate | date:'yyyy'}} We Teach Alabama </p>
                    <p class="text-center text-white footer-links">
                        <a href="">Media Resources</a> | 
                        <a href="">Terms of Use</a> | 
                        <a href="">FERPA</a> | 
                        <a href="">Accessibility</a>
                    </p>
                </div>
                <div class="px-4" style="min-width: fit-content;">
                    <div>
                        <img src="../../../../assets/images/enChoice-logo-white-letters-640px.png" style="max-width: 200px;">
                    </div>
                    <div class="color-white text-center mt-2">
                        <span>ACE Version {{packageJson.version}}</span>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>